module.exports = __webpack_public_path__ + "static/piclife_img1-b299076355d6c6bc150b408bdf4ebf34.png";